import { motion } from 'framer-motion';

const GODDESS_IMAGE = "https://images.unsplash.com/photo-1730652202040-21888c83b7d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxnb2RkZXNzJTIwc3RhdHVlJTIwbWFyYmxlJTIwYWVzdGhldGljJTIwZ3JlZWslMjBtaW5pbWFsaXN0fGVufDB8fHx8MTc3NDMwOTEyNnww&ixlib=rb-4.1.0&q=85";

export const PhilosophySection = () => {
  return (
    <section 
      data-testid="philosophy-section"
      className="py-24 lg:py-32 bg-chalk relative overflow-hidden"
    >
      {/* Background Decorative Image */}
      <div 
        className="absolute right-0 top-0 bottom-0 w-1/3 opacity-10 bg-cover bg-center hidden lg:block"
        style={{ backgroundImage: `url(${GODDESS_IMAGE})` }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <p className="font-cinzel text-amaranth text-xs tracking-[0.3em] mb-4">
              OUR PHILOSOPHY
            </p>
            <h2 className="font-serif text-dark text-4xl lg:text-5xl mb-8 leading-tight">
              Beauty is Revealed,<br />
              <span className="italic text-thulian">Not Created</span>
            </h2>
            
            <div className="space-y-6 text-dark-secondary leading-relaxed">
              <p>
                At Aphrodite Med Spa, we believe that true beauty originates from within. Our philosophy 
                centers on enhancing your natural radiance through a harmonious blend of cutting-edge 
                aesthetic medicine and holistic wellness practices.
              </p>
              <p>
                Every treatment we offer is designed to reveal the goddess within—restoring confidence, 
                vitality, and the luminous glow that reflects your inner strength. We approach beauty 
                as a celebration of individuality, never as conformity to trends.
              </p>
              <p>
                Our commitment extends beyond aesthetics. We are leaders in longevity medicine, 
                incorporating the latest advancements in peptide therapy, IV nutrition, and 
                regenerative treatments to help you feel as vibrant as you look.
              </p>
            </div>

            {/* Philosophy Points */}
            <div className="grid grid-cols-2 gap-6 mt-10">
              {[
                { title: "Holistic Approach", desc: "Beauty starts within" },
                { title: "Medical Excellence", desc: "Science-backed treatments" },
                { title: "Personalized Care", desc: "Tailored to you" },
                { title: "Lasting Results", desc: "Natural, timeless beauty" }
              ].map((point, index) => (
                <motion.div
                  key={point.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                  className="border-l-2 border-thulian pl-4"
                >
                  <h4 className="font-serif text-dark text-lg">{point.title}</h4>
                  <p className="text-dark-secondary text-sm">{point.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-5 relative"
          >
            <div className="aspect-[4/5] relative">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-longevity/artifacts/6l9slcfl_i_want_this_picture_made_in_ou_Nano_Banana_2_00260.jpg"
                alt="Aphrodite Med Spa Philosophy"
                className="w-full h-full object-cover"
              />
              {/* Decorative frame */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-thulian -z-10" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
